import React, { useState } from "react";
import toast from "react-hot-toast";
// import HttpClientXml from "../utils/HttpClientXml";
import HomeService from "../Services/HomeService";
import HttpClientXml from "../utils/HttpClientXml";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "rgb(131, 144, 155)",
  margin: "0px 0px 10px 0px",
  fontWeight: "bold",
};

function AddPersonalService() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    image: "",
    heading: "",
    subheading: "",
  });
  const [imageLoading, setImageLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate image file
    if (!file.type.startsWith("image/")) {
      toast.error("Please select a valid image file");
      return;
    }

    setImageLoading(true);

    const data = new FormData();
    data.append("image", file);

    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setFormData((prev) => ({ ...prev, image: res.image }));
        toast.success("Image uploaded successfully!");
      } else {
        toast.error(res?.message || "Failed to upload image");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setImageLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.image) {
      toast.error("Please upload an image");
      return;
    }

    if (!formData.heading.trim()) {
      toast.error("Please enter a heading");
      return;
    }

    if (!formData.subheading.trim()) {
      toast.error("Please enter a subheading");
      return;
    }

    setLoading(true);

    // Prepare data according to Postman body structure
    const serviceData = {
      image: formData.image,
      heading: formData.heading.trim(),
      subheading: formData.subheading.trim(),
    };

    console.log("Service Data:", serviceData);

    try {
      const res = await HomeService.createPersonalService(serviceData);
      console.log("result", res);
      if (res?.status) {
        toast.success("Personal service added successfully!");
        navigate("/manage-personal-service");
        clearForm();
      } else {
        toast.error(res?.message || "Failed to add personal service.");
      }
    } catch (error) {
      toast.error("Failed to add personal service.");
      console.error("Error adding personal service:", error);
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    setFormData({
      image: "",
      heading: "",
      subheading: "",
    });
  };

  const removeImage = () => {
    setFormData((prev) => ({ ...prev, image: "" }));
    toast.success("Image removed");
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add Personal Service
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Image Upload Section */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="image">
                    Upload Image<span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    id="image"
                    className="form-control"
                    onChange={handleImageUpload}
                    accept="image/*"
                    disabled={imageLoading}
                    required
                  />
                  <div className="form-text">
                    {imageLoading ? (
                      <span className="text-primary">
                        <i className="fa-solid fa-spinner fa-spin me-1"></i>
                        Uploading image...
                      </span>
                    ) : (
                      "Upload an image for the service"
                    )}
                  </div>

                  {formData.image && (
                    <div className="mt-3 position-relative">
                      <div className="alert alert-success p-2">
                        <strong>Image Preview:</strong>
                      </div>
                      <img
                        src={formData.image}
                        alt="Service Preview"
                        style={{
                          maxHeight: "200px",
                          maxWidth: "100%",
                          borderRadius: "8px",
                          border: "2px solid #dee2e6",
                          objectFit: "cover",
                        }}
                      />
                      <button
                        type="button"
                        onClick={removeImage}
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: "35px", right: "10px" }}
                      >
                        <i className="fa-solid fa-times"></i>
                      </button>
                    </div>
                  )}
                </div>

                {/* Heading Input */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="heading">
                    Heading<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="heading"
                    className="form-control"
                    name="heading"
                    value={formData.heading}
                    onChange={handleChange}
                    placeholder="Enter service heading..."
                    required
                  />
                  <div className="form-text">
                    Enter the main heading for the service
                  </div>
                </div>

                {/* Subheading Textarea */}
                <div className="col-md-12 mt-3">
                  <label htmlFor="subheading">
                    Subheading<span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="subheading"
                    className="form-control"
                    name="subheading"
                    value={formData.subheading}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Enter service subheading or description..."
                    required
                  ></textarea>
                  <div className="form-text">
                    Enter a detailed subheading or description for the service
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="row mt-4">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    disabled={loading || imageLoading}
                  >
                    {loading ? (
                      <>
                        <i className="fa-solid fa-spinner fa-spin me-2"></i>
                        Adding Service...
                      </>
                    ) : (
                      "Add Personal Service"
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mt-3 ml-2"
                    style={{
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    onClick={clearForm}
                  >
                    Clear Form
                  </button>
                </div>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddPersonalService;
